import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { Tabs, TabContainer } from '@gpstrackit/gtc-react-controls';

// Header-only tabs above the Coaching iframe, same control the Manage module uses.
// The panels are empty on purpose: the iframe lives outside the `Tabs` so it is never remounted.
// `Tabs` keeps the selected tab in its own state and only reads `tab` on mount, so later
// changes of `activeIndex` (restored tab, browser back/forward) are pushed through its ref.
const CoachingTabs = ({ tabs, activeIndex, onChange }) => {
  const { messages } = useIntl();
  const tabsRef = useRef(null);
  const activeIndexRef = useRef(activeIndex);

  useEffect(() => {
    activeIndexRef.current = activeIndex;
    tabsRef.current?.setValue(activeIndex);
  }, [activeIndex]);

  const handleChange = (index) => {
    if (index === activeIndexRef.current || !tabs[index]) return;
    onChange(tabs[index]);
  };

  return (
    <div className="coach-sso-view__tabs">
      <Tabs ref={tabsRef} tab={activeIndex} onChange={handleChange}>
        {tabs.map((tab, index) => (
          <TabContainer
            key={tab.id}
            index={index}
            label={messages[tab.labelKey] || tab.path}
            childrenProps={{ padding: 0 }}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default CoachingTabs;
